export default {
  mounted() {
    const img = this.el
    const fallback = document.getElementById("fallback-" + this.el.id)

    img.addEventListener("error", () => {
      img.classList.add("hidden");
      fallback.classList.remove("hidden");
    });
  }
}
